// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICustomPageLetterOfMedicalNecessityResponse,
} from '../models/index';
import {
    ICustomPageLetterOfMedicalNecessityResponseFromJSON,
    ICustomPageLetterOfMedicalNecessityResponseToJSON,
} from '../models/index';

export interface GetLettersOfMedicalNecessityRequest {
    searchValue?: string;
    employeeId?: number;
    validOn?: string;
    size?: number;
    page?: number;
}

/**
 * LetterOfMedicalNecessityControllerApi - interface
 * 
 * @export
 * @interface LetterOfMedicalNecessityControllerApiInterface
 */
export interface LetterOfMedicalNecessityControllerApiInterface {
    /**
     * 
     * @param {string} [searchValue] 
     * @param {number} [employeeId] 
     * @param {string} [validOn] 
     * @param {number} [size] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LetterOfMedicalNecessityControllerApiInterface
     */
    getLettersOfMedicalNecessityRaw(requestParameters: GetLettersOfMedicalNecessityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageLetterOfMedicalNecessityResponse>>;

    /**
     */
    getLettersOfMedicalNecessity(requestParameters: GetLettersOfMedicalNecessityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageLetterOfMedicalNecessityResponse>;

}

/**
 * 
 */
export class LetterOfMedicalNecessityControllerApi extends runtime.BaseAPI implements LetterOfMedicalNecessityControllerApiInterface {

    /**
     */
    async getLettersOfMedicalNecessityRaw(requestParameters: GetLettersOfMedicalNecessityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageLetterOfMedicalNecessityResponse>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['validOn'] != null) {
            queryParameters['valid_on'] = requestParameters['validOn'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/letters-of-medical-necessity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageLetterOfMedicalNecessityResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLettersOfMedicalNecessity(requestParameters: GetLettersOfMedicalNecessityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageLetterOfMedicalNecessityResponse> {
        const response = await this.getLettersOfMedicalNecessityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
